<template>
  <div class="oauth-login-page">
    <div class="login-container">
      <div class="oauth-banner" v-if="bannerImage">
        <img :src="bannerImage" alt="" />
      </div>
      <div class="error-banner" v-if="globalError">{{ globalError }}</div>
      <TabMenu :tabs="tabs" :activeTab="mode" @update-activeTab="changeMethod" />
      <Login v-if="mode === 1" ref="loginComponent" />
      <MemberSave v-if="mode === 2" ref="memberSaveComponent" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import TabMenu from '@/components/molecules/TabMenu.vue';
import Login from '@/components/organisms/Login/Login.vue';
import MemberSave from '@/components/organisms/Login/MemberSave.vue';
import t from '@/plugins/i18n';

export default {
  name: 'OAuthLogin',
  mixins: [t],

  components: {
    TabMenu,
    Login,
    MemberSave,
  },

  data: () => ({
    mode: 1,
    callbackUrl: '',
    state: '',
    bannerImage: '',
    globalError: '',
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      loginUserResult: 'user/loginUserResult',
      appendUserResult: 'user/appendUserResult',
    }),
    tabs() {
      return [
        { id: 1, label: this.t('ログイン') },
        { id: 2, label: this.t('会員登録') },
      ];
    },
  },

  mounted() {
    // クエリパラメータからcallback_url、state、modeを取得
    this.callbackUrl = this.$route.query.callback_url || '';
    this.state = this.$route.query.state || '';
    this.bannerImage = this.$route.query.banner_image || '';
    if (this.$route.query.mode === 'register') {
      this.mode = 2;
    }

    if (!this.callbackUrl) {
      this.globalError = 'callback_urlが指定されていません';
    }

    // OAuth用のセッションストレージにも保存（Googleログイン用）
    if (this.callbackUrl) {
      sessionStorage.setItem('oauth_callback_url', this.callbackUrl);
    }
    if (this.state) {
      sessionStorage.setItem('oauth_state', this.state);
    }
  },

  watch: {
    // ログイン成功を監視
    loginUserResult(newVal) {
      if (newVal && newVal.state === 200) {
        this.redirectWithToken(newVal.user);
      }
    },
    // 会員登録成功を監視
    appendUserResult(newVal) {
      if (newVal && newVal.state === 200) {
        // 登録成功後、ログイン状態になっているのでリダイレクト
        this.$store.dispatch('user/setCurrentUser').then(() => {
          const { currentUser } = this;
          if (currentUser && currentUser.is_login === '1') {
            this.redirectWithToken(currentUser.user_id);
          }
        });
      }
    },
    // currentUserの変更を監視（Googleログインなど）
    currentUser(newVal) {
      if (newVal && newVal.is_login === '1' && this.callbackUrl) {
        // すでにログインしている場合はリダイレクト
        this.redirectWithToken(newVal.user_id);
      }
    },
  },

  methods: {
    changeMethod(id) {
      this.mode = id;
    },
    async redirectWithToken(userId) {
      if (!this.callbackUrl) {
        this.globalError = 'callback_urlが指定されていません';
        return;
      }

      try {
        // OAuthトークンを生成
        const response = await axios.post('/api/oauth/token', {
          user_id: userId,
        });

        if (response.data.state === 200 && response.data.token) {
          // callback_urlにトークンを付けてリダイレクト
          const separator = this.callbackUrl.includes('?') ? '&' : '?';
          let redirectUrl = `${this.callbackUrl}${separator}token=${response.data.token}`;
          if (this.state) {
            redirectUrl = `${redirectUrl}&state=${this.state}`;
          }
          window.location.href = redirectUrl;
        } else {
          this.globalError = 'トークンの生成に失敗しました';
        }
      } catch (e) {
        this.globalError = 'トークンの生成に失敗しました';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.oauth-login-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 20px;
  background: #fff;
}

.login-container {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  width: 100%;
  max-width: 600px;
}

.oauth-banner {
  text-align: center;
  margin-bottom: 16px;

  img {
    max-height: 60px;
    max-width: 100%;
    object-fit: contain;
  }
}

.error-banner {
  background: #ffebee;
  color: #c62828;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .oauth-login-page {
    padding: 20px 10px;
    align-items: flex-start;
  }

  .login-container {
    padding: 20px 15px;
    max-width: 100%;
  }
}
</style>

<style lang="scss">
/* チェックボックスのスタイル修正（非scoped） */
.oauth-login-page {
  .check-box {
    width: 25px !important;
    height: 25px !important;
    min-width: 25px !important;
    border: solid 2px #20366f !important;
    border-radius: 4px !important;
    background: #fff !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;

    i,
    svg {
      display: none !important;
    }

    &.active {
      background: #20366f !important;

      &::after {
        content: "✓" !important;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        line-height: 1;
      }
    }
  }
}
</style>
